import { useState, useEffect } from 'react';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';

interface Size {
	width: number | undefined;
	height: number | undefined;
}

const useWindowSize = () => {
	const [windowSize, setWindowSize] = useState<Size>({
		width: undefined,
		height: undefined,
	});

	const setWindowSizeDebounced = useDebouncedCallback((size: Size) => setWindowSize(size), 500);

	useEffect(() => {
		function handleResize() {
			setWindowSizeDebounced({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}
		// Add event listener
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowSize;
};

export default useWindowSize;
